import React, { useState } from 'react';
import './Terminal.css';

const Terminal = () => {
  const [terminalState, setTerminalState] = useState('maximized');
  const [isReloading, setIsReloading] = useState(false);
  const [contentVisible, setContentVisible] = useState(true);

  const closeTerminal = () => {
    setTerminalState('closed');
  };

  const restartTerminal = () => {
    setTerminalState('normal');
    setTimeout(() => {
      refreshTerminal();
    }, 300);
  };

  const minimizeTerminal = () => {
    setTerminalState(terminalState === 'minimized' ? 'normal' : 'minimized');
  };

  const maximizeTerminal = () => {
    setTerminalState(terminalState === 'maximized' ? 'normal' : 'maximized');
  };

  const refreshTerminal = () => {
    setIsReloading(true);
    setContentVisible(false);
    setTimeout(() => {
      setContentVisible(true);
      setIsReloading(false);
    }, 400);
  };

  return (
    <div className="terminal-wrapper">
      {terminalState === 'closed' ? (
        <button className="restart-terminal-btn" onClick={restartTerminal}>
          <i className="fas fa-terminal"></i> Restart Terminal
        </button>
      ) : (
        <div className={`terminal-container ${terminalState}`}>
          <div className="terminal-header">
            <div className="terminal-left">
              <div className="terminal-dots">
                <div className="dot dot-red" onClick={closeTerminal} title="Close"></div>
                <div className="dot dot-yellow" onClick={minimizeTerminal} title="Minimize"></div>
                <div className="dot dot-green" onClick={maximizeTerminal} title="Maximize"></div>
              </div>
              <div className="terminal-title">anshul.work</div>
            </div>
            <div className="terminal-actions">
              <div
                className={`terminal-action ${isReloading ? 'refreshing' : ''}`}
                onClick={refreshTerminal}
                title="Refresh"
              >
                <i className="fas fa-sync-alt"></i>
              </div>
            </div>
          </div>
          <div className={`terminal-content ${terminalState}`}>
            {contentVisible ? (
              <div className={`terminal-text ${isReloading ? 'reload-animation' : ''}`}>
                <p className="hero-pre">Hello, World</p>
                <h1 className="hero-title">Anshul Thakur</h1>
                <h2 className="hero-subtitle">CTO | Tech Leadership & Digital Transformation</h2>
                <p className="hero-description">
                  Leading technical transformation across diverse industries for 8+ years.
                  Building platforms processing 1M+ daily transactions while reducing
                  operational costs by up to 65% & achieving 99.99% uptime.
                </p>
                <div className="terminal-prompt">
                  <span className="prompt-sign">$</span>
                  <p className="typing-animation">Let's connect and build something innovative</p>
                </div>
                <div className="terminal-buttons">
                  <a href="#evolution" className="btn btn-primary">View Journey</a>
                  <a href="#contact" className="btn btn-outline">Contact Me</a>
                </div>
              </div>
            ) : (
              <div className="terminal-loading">
                <span className="loading-cursor"></span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Terminal;
